import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { PLANS } from '../../constants/plans'
import { isOnFreeTrial } from '../../utils/general'
import styles from './AICreatorBanner.module.css'

const STORAGE_KEY = 'aiCreatorBannerClosed'
const AI_CREATOR_URL = 'https://tiiny.host/create'
const PAID_BANNER_PLAN_IDS = [PLANS.TINY.id, PLANS.PRO.id, PLANS.PRO_U.id, PLANS.PRO_MAX.id]

const AICreatorBanner = ({ userProfile }) => {
  const [show, setShow] = useState(true)

  const shouldShow =
    PAID_BANNER_PLAN_IDS.includes(userProfile?.productId) &&
    !isOnFreeTrial(userProfile) &&
    localStorage.getItem(STORAGE_KEY) !== 'true'

  if (!shouldShow || !show) return null

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()
    localStorage.setItem(STORAGE_KEY, 'true')
    setShow(false)
  }

  const handleOpenAICreator = () => {
    window.open(AI_CREATOR_URL, '_blank', 'noopener,noreferrer')
  }

  return (
    <div className={styles.bannerContainer} onClick={handleOpenAICreator}>
      <div className={styles.bannerContent}>
        <button type="button" className={styles.closeButton} onClick={handleClose}>
          <img src="/assets/icons/cancel_white.svg" height="15" width="15" alt="cancel" />
        </button>

        <div className={styles.contentWrapper}>
          <div className={styles.iconSection}>
            <img
              src="/assets/icons/openai.svg"
              width="24"
              height="24"
              alt="AI Creator"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </div>
          <div className={styles.textSection}>
            <h4 className={styles.title}>Create anything with AI - and publish it on Tiiny Host</h4>
            <p className={styles.subtitle}>
              Try our AI Creator and build a beautiful website, portfolio, tool, or anything else. Then easily publish
              it.
            </p>
          </div>

          <div className={styles.buttonSection}>
            <Button variant="outline-light" className={styles.tryButton} data-testid="AICreatorBanner-button-try">
              Try it now
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AICreatorBanner
